import { AuditReportsGipReportMatchedScheduleDto } from '@mi-front/api-v2';
import { useMemo, useState } from 'react';

export function useGipReportResultFilter_v2(schedules: AuditReportsGipReportMatchedScheduleDto[]) {
  const [showOffTolerance, setShowOffTolerance] = useState(true);

  const filteredItems = useMemo(() => {
    if (showOffTolerance) {
      return schedules;
    }

    return schedules.filter(
      (i) =>
        i.match.matchedScheduleConfirmationType &&
        i.match.matchedScheduleConfirmationType === 'DEFAULT',
    );
  }, [schedules, showOffTolerance]);

  return {
    showOffTolerance,
    setShowOffTolerance,
    filteredItems,
  };
}
